import { render } from "./brandcheckView.vue?vue&type=template&id=4a00054c"
import script from "./brandcheckView.vue?vue&type=script&lang=js"
export * from "./brandcheckView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__